import React from "react";
import "./Art.css";

function Art(){
    return(
        <div className="art">
            <div className="art-content">
                <span className="art-content-head">I <span style={{color:"#ffcb74"}}>draw</span> in my <br></br>free time</span><br/>
                <p className="art-content-content">I love drawing miniature<br/> city landscapes,
                expressing <br/>all my thoughts on a piece <br/>of paper.<br/></p>
                <p className="art-content-content">
                Follow my insta account<br/><span style={{color:"#ffcb74"}} className="insta-art"> <i>@the_mayankism</i></span><br/>
                and have a look at my art work</p>
            </div>
            <div className="left-art-img">
                <img className='art-img' src="/Assets/city-img2.png" alt = "city-landscape"></img>
            </div>
            {/* <div className="right-art-img">

            </div> */}
            {/* <div className="left-art-img">
                <img className='art-img' src="/Assets/city-img1.png" alt = "city-landscape"></img>
            </div> */}
        </div>
    );
}

export default Art;